import script from "./RacDeferimentoEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RacDeferimentoEditPage.vue?vue&type=script&setup=true&lang=js"

import "./RacDeferimentoEditPage.vue?vue&type=style&index=0&id=401dfa78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401dfa78"]])

export default __exports__